import { CircularProgress, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import React from 'react';


const ColorCircularProgress = withStyles((theme) => ({
    root: {
        color: theme.palette.common.black,
        marginBottom: theme.spacing(2),
    },
}))(CircularProgress);

export default function CustomCircularProgress(props) {
    const {size, center} = props;
    return ( 
        <Grid xs={12} item container justifyContent={!center ? 'center' : ''}>
            <ColorCircularProgress size={size ? size : 20} thickness={5} />
        </Grid>
    );
}
